import CategoryFixed from "./CategoryFixed";
import CategoryFixedMobile from "./CategoryFixedMobile";
import {Link} from "react-router-dom";
import s from "./CategoryCardTop.module.scss";

const CategoryCardTop = ({categories, onCategoryClick,activeCategory }) => {
    return (
        <>
            <div className={s.categoryHeader}>
                <Link className={s.allToursLink} to="/all-tours">
                    すべてのツアー
                    <i className="fa fa-arrow-right" aria-hidden="true"/>
                </Link>
            </div>
            <CategoryFixed
                categories={categories}
                onCategoryClick={onCategoryClick}
                activeCategory={activeCategory}
            />
            <CategoryFixedMobile
                categories={categories}
                onCategoryClick={onCategoryClick}
                activeCategory={activeCategory}
            />
        </>
    );
};

export default CategoryCardTop;
